import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import BlogSidebarMain from "./BlogSidebarMain";
import Footer from "../../components/Footer";

const BlogSidebar = () => {
  return (
    <>
      <HeaderFour />

      <BlogSidebarMain />

      <Footer />
    </>
  );
};

export default BlogSidebar;
